import React from 'react';
import './ProjectModal.css';

const ProjectModal = ({ isOpen, onClose, project }) => {
  if (!isOpen || !project) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          {project.companyLogo && (
            <img src={project.companyLogo} alt="Company Logo" className="modal-company-logo" />
          )}
          <div>
            <h3 className="modal-role-title">{project.roleTitle}</h3>
            <h1 className="modal-project-headline">{project.projectHeadline}</h1>
          </div>
        </div>

        <div className="modal-body">
          {project.demoVideo ? (
            <div className="modal-video">
              <iframe 
                width="100%" 
                height="400" 
                src={project.demoVideo} 
                title="Project Demo"
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <img src={project.screenshot} alt="Project Screenshot" className="modal-screenshot" />
          )}

          <div className="modal-description">
            <p>{project.projectDescription}</p>
            {project.detailedDescription && (
              <div className="modal-detailed-description">
                <h3>Project Details</h3>
                <p>{project.detailedDescription}</p>
              </div>
            )}
          </div>

          <div className="modal-tags">
            {project.tags.map((tag, index) => (
              <span className="modal-tag" key={index}>{tag}</span>
            ))}
          </div>

          <div className="modal-links">
            {project.githubUrl && (
              <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="modal-link">
                GitHub Repository
              </a>
            )}
            {project.demoUrl && (
              <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="modal-link">
                Live Demo
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;